// This script handles direct navigation to anchor links from URL hashes
// It's designed to run on the client side after the DOM is loaded

// We need to export a function for Gatsby to recognize this as a valid module
export const initScrollOffset = () => {
  if (typeof window !== 'undefined') {
    // Run after DOM content is fully loaded
    window.addEventListener('DOMContentLoaded', () => {
      // If there's a hash in the URL
      if (window.location.hash) {
        // Get the target element
        const targetId = window.location.hash.substring(1)
        const targetElement = document.getElementById(targetId)
        
        if (targetElement) {
          // Wait a moment for the page to fully render
          setTimeout(() => {
            // Get the navbar height
            const navbar = document.querySelector('header') || { offsetHeight: 80 }
            const navbarHeight = navbar.offsetHeight || 80
            
            // Calculate the position to scroll to
            const elementPosition = targetElement.getBoundingClientRect().top
            const offsetPosition = elementPosition + window.pageYOffset - navbarHeight - 16
            
            // Scroll to the element
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            })
          }, 300) // Small delay to ensure everything is rendered
        }
      }
    })
  }
}

// Add scroll-margin-top to all headings with IDs
export const addScrollMarginToHeadings = () => {
  if (typeof window !== 'undefined') {
    window.addEventListener('DOMContentLoaded', () => {
      // Target all headings that might have IDs
      const headings = document.querySelectorAll('h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]')
      
      // Calculate navbar height
      const navbar = document.querySelector('header') || { offsetHeight: 80 }
      const navbarHeight = navbar.offsetHeight || 80
      
      // Apply scroll margin to all headings
      headings.forEach(heading => {
        heading.style.scrollMarginTop = `${navbarHeight + 16}px`
      })
    })
  }
}